<template>
  <div class="container-fluid border-end">
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="transferBatchNo" class="form-label"
          >Transfer Batch No. / Transferring Agency / Transfer UUID / SIP UUID /
          Item ID</label
        >
        <input
          type="text"
          class="form-control"
          id="transferBatchNo"
          v-model="transfer_batch"
        />
      </div>
      <!-- <div class="mb-3">
        <label for="transferringAgency" class="form-label"
          >Transferring Agency</label
        >
        <input
          type="text"
          class="form-control"
          id="transferringAgency"
          v-model="transferringAgency"
        />
      </div> -->
      <div class="mb-3">
        <label for="securityGrading" class="form-label">Security Grading</label>
        <select
          id="securityGrading"
          class="form-select"
          v-model="securityGrading"
        >
          <option value=""></option>
          <option value="[`Official (Open)`]">Official (Open)</option>
          <option value="[`Official (Closed)`]">Official (Closed)</option>
          <option value="[`Restricted`]">Restricted</option>
          <option value="[`Confidential (Cloud-eligible)`]">
            Confidential (Cloud-eligible)
          </option>
          <option value="[`Confidential`]">Confidential</option>
          <option value="[`Secret`]">Secret</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="sensitivityClassification" class="form-label"
          >Sensitivity Classification</label
        >
        <select
          id="sensitivityClassification"
          class="form-select"
          v-model="sensitivityClassification"
        >
          <option value=""></option>
          <option value="[`Non-Sensitive`]">Non-Sensitive</option>
          <option value="[`Sensitive Normal`]">Sensitive Normal</option>
          <option value="[`Sensitive High`]">Sensitive High</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="status" class="form-label">Status</label>
        <select id="status" class="form-select" v-model="status">
          <option value=""></option>
          <option value="Unknown">Unknown</option>
          <option value="Stored">Stored</option>
          <option value="Reingesting">Reingesting</option>
          <option value="Failed">Failed</option>
          <option value="Stalled">Stalled</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="statusDate" class="form-label">Transfer Date</label>
        <input
          type="date"
          class="form-control"
          id="statusDate"
          v-model="statusDate"
        />
      </div>
      <div class="mb-3">
        <label for="fixityCheckPassed" class="form-label">Fixity Check</label>
        <select
          id="fixityCheckPassed"
          class="form-select"
          v-model="fixityCheckPassed"
        >
          <option value=""></option>
          <option value="true">Passed</option>
          <option value="false">Failed</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="fixityCheckedAtStart" class="form-label"
          >Fixity Checked At Range - Start</label
        >
        <input
          type="date"
          class="form-control"
          id="fixityCheckedAtStart"
          v-model="fixityCheckedAtStart"
        />
      </div>
      <div class="mb-3">
        <label for="fixityCheckedAtEnd" class="form-label"
          >Fixity Checked At Range - End</label
        >
        <input
          type="date"
          class="form-control"
          id="fixityCheckedAtEnd"
          v-model="fixityCheckedAtEnd"
        />
      </div>
      <fieldset class="mb-3">
        <legend class="col-form-label pt-0">Type</legend>
        <div>
          <div class="form-check form-check-inline col-6">
            <input
              class="form-check-input"
              type="checkbox"
              id="aip"
              v-model="aip"
            />
            <label class="form-check-label" for="aip">AIP</label>
          </div>
          <div class="form-check form-check-inline col">
            <input
              class="form-check-input"
              type="checkbox"
              id="dip"
              v-model="dip"
            />
            <label class="form-check-label" for="dip">DIP</label>
          </div>
        </div>
      </fieldset>
      <div class="d-grid gap-2 mx-auto">
        <div class="d-block">
          <button
            class="btn btn-clear btn-outline-secondary"
            type="button"
            @click="clear"
          >
            Clear All
          </button>
          <button
            class="btn btn-search btn-primary"
            type="button"
            @click="submitForm"
          >
            Search
          </button>
        </div>
        <!-- <div class="d-block">
          <button
            class="btn btn-search btn-primary"
            type="button"
            @click="submitForm"
          >
            Search
          </button>
        </div> -->
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { useTypesenseStore } from "@/stores/typesense";
import moment from "moment";
import { ref } from "vue";
import { useAuditStore } from "@/stores/audit";

const emit = defineEmits(["listen-search"]);
const typesenseStore = useTypesenseStore();
const audit = useAuditStore();

const transfer_batch = ref(typesenseStore.searchField.transfer_batch);
const transferringAgency = ref(typesenseStore.searchField.transfer_agency);
const securityGrading = ref(typesenseStore.searchField.security_grading);
const sensitivityClassification = ref(
  typesenseStore.searchField.sensitivity_classification
);
const status = ref(typesenseStore.searchField.status);
const statusDate = ref(typesenseStore.searchData.raw_transfer_date);
const convertedStatusDate = ref(typesenseStore.searchField.transfer_date);
const aip = ref(typesenseStore.searchData.aip);
const dip = ref(typesenseStore.searchData.dip);
const type = ref(typesenseStore.searchField.type);
const dayRange = 86399;
const fixityCheckPassed = ref(typesenseStore.searchField.fixity_check_passed);
const fixityCheckedAtStart = ref(
  typesenseStore.searchData.fixity_checked_at_start
);
const fixityCheckedAtEnd = ref(typesenseStore.searchData.fixity_checked_at_end);
const convertedFixityCheckedAt = ref(
  typesenseStore.searchField.fixity_checked_at
);

const clear = () => {
  transfer_batch.value = "";
  transferringAgency.value = "";
  securityGrading.value = "";
  sensitivityClassification.value = "";
  status.value = "";
  statusDate.value = "";
  convertedStatusDate.value = "";
  aip.value = true;
  dip.value = true;
  type.value = "";
  fixityCheckPassed.value = "";
  fixityCheckedAtStart.value = "";
  fixityCheckedAtEnd.value = "";
  convertedFixityCheckedAt.value = "";
  let searchField = {
    transfer_batch: transfer_batch.value,
    transfer_agency: transferringAgency.value,
    security_grading: securityGrading.value,
    sensitivity_classification: sensitivityClassification.value,
    status: status.value,
    transfer_date: convertedStatusDate.value,
    type: type.value,
    fixity_check_passed: fixityCheckPassed.value,
    fixity_checked_at: convertedFixityCheckedAt.value,
  };
  let searchData = {
    raw_transfer_date: statusDate.value,
    aip: aip.value,
    dip: dip.value,
    fixity_checked_at_start: fixityCheckedAtStart.value,
    fixity_checked_at_end: fixityCheckedAtEnd.value,
  };
  typesenseStore.storeSearchBar(searchField, searchData);
  emit("listen-search", searchField);
};

const submitForm = () => {
  audit.auditLog("Search");
  if ((!aip.value && !dip.value) || (aip.value && dip.value)) type.value = "";
  if (aip.value && !dip.value) type.value = "AIP";
  if (!aip.value && dip.value) type.value = "DIP";

  if (statusDate.value)
    convertedStatusDate.value = `[${moment(statusDate.value).unix()}..${
      moment(statusDate.value).unix() + dayRange
    }]`;

  if (fixityCheckedAtStart.value && fixityCheckedAtEnd.value) {
    convertedFixityCheckedAt.value = `[${moment(
      fixityCheckedAtStart.value
    ).unix()}..${moment(fixityCheckedAtEnd.value).unix() + dayRange}]`;
  } else if (fixityCheckedAtStart.value) {
    convertedFixityCheckedAt.value = `[${moment(
      fixityCheckedAtStart.value
    ).unix()}..${moment(fixityCheckedAtStart.value).unix() + dayRange}]`;
  } else if (fixityCheckedAtEnd.value) {
    convertedFixityCheckedAt.value = `[${moment(
      fixityCheckedAtEnd.value
    ).unix()}..${moment(fixityCheckedAtEnd.value).unix() + dayRange}]`;
  }

  let searchField = {
    transfer_batch: transfer_batch.value,
    transfer_agency: transferringAgency.value,
    security_grading: securityGrading.value,
    sensitivity_classification: sensitivityClassification.value,
    status: status.value,
    transfer_date: convertedStatusDate.value,
    type: type.value,
    fixity_check_passed: fixityCheckPassed.value,
    fixity_checked_at: convertedFixityCheckedAt.value,
  };
  let searchData = {
    raw_transfer_date: statusDate.value,
    aip: aip.value,
    dip: dip.value,
    fixity_checked_at_start: fixityCheckedAtStart.value,
    fixity_checked_at_end: fixityCheckedAtEnd.value,
  };
  typesenseStore.storeSearchBar(searchField, searchData);
  emit("listen-search", searchField);
};
</script>

<style scoped>
.container-fluid {
  position: fixed;
  padding-top: 20px;
  width: 24%;
  /* background: pink; */
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
}
.btn-clear {
  margin-top: 1rem;
  margin-right: 1%;
  width: 49%;
}
.btn-search {
  margin-top: 1rem;
  margin-left: 1%;
  width: 49%;
}
</style>
